import { ChipProps, SvgIcon } from '@mui/material';
import { FC } from 'react';
import ArrowDown from '../../../../../../../../../../icons/svg/arrow_down.svg?react';
import { Chip } from '../../../../../../../../../atomic';

type Props = {
  count: number;
  onMoreClick: ChipProps['onDelete'];
};

export const TableRoofMoreChip: FC<Props> = ({ count, onMoreClick }) => {
  return (
    <Chip
      color="heaven"
      label={`+ ${count}`}
      onDelete={onMoreClick}
      onClick={onMoreClick}
      deleteIcon={<SvgIcon component={ArrowDown} inheritViewBox />}
    />
  );
};
